enum SimulatedPlayerStatuse {
    ONLINE = 'online',
    OFFLINE = 'offline'
}
export class SetSimulatedPlayerStatus {
    private static instance: SetSimulatedPlayerStatus;
    private clientStatusBlock: JQuery;
    constructor() {
        this.clientStatusBlock = $('#player-simulated-status span');
    }

    public static getInstance(): SetSimulatedPlayerStatus {
        if (typeof SetSimulatedPlayerStatus.instance === 'undefined') {
            SetSimulatedPlayerStatus.instance = new SetSimulatedPlayerStatus();
        }

        return SetSimulatedPlayerStatus.instance;
    }

    setOnline() {
        this.clientStatusBlock.addClass('online').text(SimulatedPlayerStatuse.ONLINE);
    }

    setOffline() {
        this.clientStatusBlock.removeClass('online').text(SimulatedPlayerStatuse.OFFLINE);
    }
}
